import React, { memo } from 'react';
import Image from 'next/image';
import styles from './CarFinance.module.scss';
import type { BankData } from '@interfaces/CarFinance.types';

interface PartneredBanksProps {
  bankArray: BankData[];
}

export const PartneredBanks = memo(({ bankArray }: PartneredBanksProps) => {
  return (
    <div className={styles.partneredBanksRow}>
      <span className={styles.partneredBanksLabel}>
        Our partnered banks:
      </span>
      <span className={styles.bankIcons}>
        {bankArray?.map((bank) => (
          <Image
            key={bank.provider_name}
            src={bank.logo_image}
            alt={bank.provider_name}
            width={20}
            height={20}
            className={styles.bankLogo}
            loading="lazy"
          />
        ))}
      </span>
    </div>
  );
});

PartneredBanks.displayName = 'PartneredBanks';
